var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.gcInvite_inviteInfo.invitee_terms_more_ui)?_c('div',{staticClass:"mb-n2 term-box ql-editor",domProps:{"innerHTML":_vm._s(_vm.gcInvite_inviteInfo.invitee_terms_html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }